import styled from 'styled-components';

const OverviewWrapper = styled.div`
  .section-settings {
    margin-top: var(--size-8);
  }
`;

const ImageWrapper = styled.div`
  align-items: center;
  background-color: var(--color-gray-50);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  height: 40px;
  justify-content: center;
  margin-bottom: 6px;
  width: 40px;
`;

export { ImageWrapper, OverviewWrapper };
